/*
 * @Description: 首页
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/pcHome.vue'
const homeRouter: Array<RouteRecordRaw> = [
    {
        path: '/home',
        component: Layout,
        redirect: '/home/welcome',
        children: [
            {
                path: 'welcome',
                component: () => import(/* webpackChunkName: "Welcome" */ '@/views/welcome/index.vue'),
                name: 'Welcome',
                meta: { title: '系统首页', },
            },
        ]
    }
]

export default homeRouter
